var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.272 18.264H29.7278C23.2152 18.264 17.9358 23.5435 17.9358 30.056V112.6C17.9358 119.113 23.2152 124.392 29.7278 124.392H112.272C118.784 124.392 124.064 119.113 124.064 112.6V30.056C124.064 23.5435 118.784 18.264 112.272 18.264Z",
    stroke: "#3A383B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3638 59.5361C55.2482 59.5361 59.2078 55.5765 59.2078 50.6921C59.2078 45.8077 55.2482 41.8481 50.3638 41.8481C45.4794 41.8481 41.5198 45.8077 41.5198 50.6921C41.5198 55.5765 45.4794 59.5361 50.3638 59.5361Z",
    stroke: "#3A383B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.064 89.0161L94.5838 59.5361L29.7278 124.392",
    stroke: "#3A383B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/noImage.5459c9888007c56289d120795ad805ea.svg";
export { ForwardRef as ReactComponent };